import { t } from 'ttag'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useContext, useState } from 'react'
import styled from 'styled-components'

import { Text } from '@h2/components/typography/text'
import { Heading } from '@h2/components/typography/heading'
import { EducatorsCodeIcon, ExternalLinkAltIcon, CopyIcon } from '@h2/components/icons'
import { Flex } from '@h2/components/layout/flex'
import { BLACK, PB97T, WHITE, PB80T, SG90T } from '@h2/components/colors'
import { Globals } from '@h2/globals'

const StyledBox = styled.div`
  padding: 15px;
  border: 3px solid ${BLACK};
  background-color: ${SG90T};
  margin-bottom: 15px;
`
const LargeButtonLike = styled.div`
  min-height: 50px;
  border: 1px solid ${PB80T};
  background-color: ${WHITE};
  margin-bottom: 15px;
  padding: 8px;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
  &:hover {
    background-color: ${PB97T};
  }
`
const CopyToClip = ({ text, isLarge, onCopy, isCopied }) => {
  return (
    <CopyToClipboard text={text} onCopy={onCopy}>
      <div>
        <LargeButtonLike>
          <Flex gap="5px" justifyContent="center" alignItems="center">
            <CopyIcon />
            <Text
              size={isLarge ? 'large' : 'default'}
              weight={isLarge ? 'bold' : 'normal'}
              align="center"
              transform={isLarge ? 'uppercase' : 'normal'}>
              {text}
            </Text>
          </Flex>

          <span className="sr-only">{t`Copy to clipboard`}</span>
        </LargeButtonLike>
        {isCopied && (
          <Text
            align="center"
            style={{
              fontStyle: 'italic',
              fontSize: '.9rem',
              color: 'green',
              marginTop: '5px'
            }}>
            {t`Copied to Clipboard`}
          </Text>
        )}
      </div>
    </CopyToClipboard>
  )
}
const AddExplorers = () => {
  const [selectedId, setSelectedId] = useState(null)
  const { user } = useContext(Globals)

  return (
    <div>
      <Text size="large">
        {t`Your navigator code will allow explorers to connect their accounts to yours so that you can track their progress and report on their work.`}
      </Text>
      <StyledBox>
        <Text size="large" align="center" weight="bold">
          {t`There are two ways you can distribute your code:`}
        </Text>
        <Flex gap="15px">
          <div>
            <Heading level="3">
              <EducatorsCodeIcon />
              {t`Just the Code`}
            </Heading>

            {user.management && (
              <div style={{ marginBottom: '15px', minHeight: '50px' }}>
                <CopyToClip
                  isLarge="true"
                  text={user.management.code?.toUpperCase()}
                  isCopied={selectedId === 'code'}
                  onCopy={() => setSelectedId('code')}
                />
              </div>
            )}
            <Text>{t`The code can be easily distributed so explorers can either enter it during registration, or in the career hub.`}</Text>
          </div>
          <div>
            <Heading level="3">
              <ExternalLinkAltIcon />
              {t`Via Magic Link`}
            </Heading>
            {user.management && (
              <div style={{ marginBottom: '15px', minHeight: '50px' }}>
                <CopyToClip
                  text={user.management.magicLink}
                  isCopied={selectedId === 'link'}
                  onCopy={() => setSelectedId('link')}
                />
              </div>
            )}
            <Text>{t`The link above can be e-mailed to users or distributed however you would like.`}</Text>
            <Text>{t`After accessing your link, users will be asked to sign in or register so they can accept you as their account manager.`}</Text>
          </div>
        </Flex>
      </StyledBox>
    </div>
  )
}

export { AddExplorers }
